import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ProductDetail,
  ProductDetailsDataService,
  ProductQuotation,
  ProductVersion,
  ProductViBooksAvailabilityModel,
} from '@vi-succ/products-domain';
import { Observable, map } from 'rxjs';
import { ApiProductDetail } from '../entity/catalog-detail';
import { environment } from '../environments/environment';
import { ProductDetailFactory } from '../factories/product-detail.factory';

@Injectable({
  providedIn: 'root',
})
export class EtProductDetailDataService implements ProductDetailsDataService {
  constructor(private http: HttpClient) {}

  getProductDetail(salesOrg: string, language: string, materialNumber: string): Observable<ProductDetail> {
    return this.http
      .get<ApiProductDetail>(`${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}`)
      .pipe(map((hit) => ProductDetailFactory.build(hit)));
  }

  getQuotationText(salesOrg: string, language: string, materialNumber: string): Observable<ProductQuotation> {
    return this.http.get<ProductQuotation>(
      `${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}/quotation-text`,
    );
  }

  getAllPredecessorsSuccessors(
    salesOrg: string,
    language: string,
    materialNumber: string,
  ): Observable<ProductVersion[]> {
    return this.http.get<ProductVersion[]>(
      `${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}/predecessor-successor-list`,
    );
  }

  getViBooksAvailability(materialNumber: string): Observable<ProductViBooksAvailabilityModel> {
    console.log('Fetching ViBooks availability for', materialNumber);
    return this.http.get<ProductViBooksAvailabilityModel>(
      environment.backend.url + `/vibooks/${materialNumber}/availability`,
    );
  }
}
